import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SvgIconComponent, SvgIcons } from '@ngneat/svg-icon';

import { RouteSegments } from '@shared/enums';

@Component({
  selector: 'app-side-menu-item',
  templateUrl: './side-menu-item.component.html',
  styleUrls: ['./side-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RouterLink, RouterLinkActive, SvgIconComponent],
})
export class SideMenuItemComponent {
  public isSideMenuOpen = input.required<boolean>();
  public routeSegments = input<RouteSegments[]>();
  public isExactRoute = input(false);
  public iconKey = input<SvgIcons>();
  public label = input.required<string>();

  public navigationClick = output<MouseEvent>();

  public onNavigationClick(event: MouseEvent): void {
    this.navigationClick.emit(event);
  }
}
